import {plainObject} from "../../../../__snowpack__/link/packages/utils/dist/utils.esm.js";
export function getFirstErrorName(errors) {
  let [key, value] = Object.entries(errors)[0];
  let name = key;
  while (value && typeof value === "object") {
    [key, value] = Object.entries(value)[0];
    name += `.${key}`;
  }
  return name;
}
export function getErrorNames(errors) {
  return plainObject(errors);
}
